export const FETCH_ALL = 'users/FETCH_ALL';
export const FETCH_ALL_SUCCESS = 'users/FETCH_ALL_SUCCESS';
export const FETCH_ALL_ERROR = 'users/FETCH_ALL_ERROR';

export const FETCH = 'users/FETCH';
export const FETCH_SUCCESS = 'users/FETCH_SUCCESS';
export const FETCH_ERROR = 'users/FETCH_ERROR';

export const FETCH_ALL_SPACE_MEMBERS = 'users/FETCH_ALL_SPACE_MEMBERS';
export const FETCH_ALL_SPACE_MEMBERS_SUCCESS = 'users/FETCH_SUCCESS_ALL_SPACE_MEMBERS';
export const FETCH_ALL_SPACE_MEMBERS_ERROR = 'users/FETCH_ERROR_ALL_SPACE_MEMBERS';

export const FETCH_ALL_AUTHORS = 'users/FETCH_AUTHORS_ALL';
export const FETCH_ALL_AUTHORS_SUCCESS = 'users/FETCH_ALL_AUTHORS_SUCCESS';
export const FETCH_ALL_AUTHORS_ERROR = 'users/FETCH_ALL_AUTHORS_ERROR';

export const CREATE = 'users/CREATE';
export const CREATE_SUCCESS = 'users/CREATE_SUCCESS';
export const CREATE_ERROR = 'users/CREATE_ERROR';

export const UPDATE = 'users/UPDATE';
export const UPDATE_SUCCESS = 'users/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'users/UPDATE_ERROR';

export const DELETE = 'users/DELETE';
export const DELETE_SUCCESS = 'users/DELETE_SUCCESS';
export const DELETE_ERROR = 'users/DELETE_ERROR';

export const SET_EDITING_USER_ID = 'users/SET_EDITING_USER_ID';
